import { LOADING_ASSET, LOAD_ASSETS_FOR_CONTAINER, SET_SELECTED_ASSET_ID, UPDATE_SEARCH_STRING } from '../actions';

export const initialState = {
  loading: false,
  searchString: ''
};

const asset = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ASSET:
      return {
        ...state,
        loading: action.loading
      };
    case LOAD_ASSETS_FOR_CONTAINER:
      return {
        ...state,
        loading: false,
        assets: {
          entities: action.assets.reduce((map, asset) => {
            map[asset.id] = asset;
            return map;
          }, {}),
          ids: action.assets.map(asset => asset.id)
        }
      };
    case SET_SELECTED_ASSET_ID:
      return {
        ...state,
        selectedAssetId: action.selectedAssetId
      };
    case UPDATE_SEARCH_STRING:
      return {
        ...state,
        searchString: action.searchString
      };
    default:
      return state;
  }
};

export default asset;



// WEBPACK FOOTER //
// ./src/reducers/asset.js